const routeTitles = {
  billing: {
    title: "Billing",
    path: "billing"
  },
  settings: {
    title: "Settings",
    path: "settings"
  },
  projects: {
    title: "Projects",
    path: "projects"
  }
};

export default routeTitles;
